<template src="./template.html"></template>

<script>
export default {
  name: "AdTypeDelete",
  data() {
    return {
      ProjectTypeID: 0,
      dialog: false
    }
  },
  methods: {
    Open(id) {
      this.ProjectTypeID = parseInt(id)
      this.dialog = true
    },
    Close() {
      this.ProjectTypeID = 0
      this.dialog = false
    },
    async DeleteData() {
      this.$store.commit("SetLoading", true)
      let response = await this.SendData("/admin/project/type", "delete", { Data: { ProjectTypeID: this.ProjectTypeID } })
      this.$store.commit("SetLoading", false)
      if (response != "error") {
        this.Close()
        this.$emit("load-data")
        this.$store.commit("SetSnackBar", { status: true, content: "已成功刪除廣告類型" })
      }
    }
  }
}
</script>